import { GALLERY_LOADING } from "./types";
// import { CREATE_GALLERY } from "./types";
// import { EDIT_GALLERY } from "./types";
// import { DELETE_GALLERY } from "./types";
// import { DELETE_GALLERY_FAIL } from "./types";
// import { EDIT_GALLERY_FAIL } from "./types";
// import { CREATE_GALLERY_FAIL } from "./types";
import { GALLERY_LOADING_END } from "./types";
import { GET_GALLERY } from "./types";
import firebase from "firebase";

export const getGallery = () => async (dispatch) => {
  await dispatch({ type: GALLERY_LOADING });
  await firebase
    .firestore()
    .collection("gallery")
    .onSnapshot(async (snapshot) => {
      let users = [];
      for (let doc of snapshot.docs) {
        users.push({ id: doc.id, ...doc.data() });
      }
      await dispatch({ type: GET_GALLERY, gallery: users });
      await dispatch({ type: GALLERY_LOADING_END });
    });
};
// export const createFeedback = (feedback) => async (dispatch) => {
//   await dispatch({ type: GALLERY_LOADING });
//   await firebase
//     .firestore()
//     .collection("gallery")
//     .add({ ...feedback })
//     .then((res) => {
//       dispatch({ type: CREATE_GALLERY });
//       dispatch({ type: GALLERY_LOADING_END });
//     })
//     .catch((err) => {
//       console.log(err);
//       dispatch({ type: CREATE_GALLERY_FAIL });
//       dispatch({ type: GALLERY_LOADING_END });
//     });
// };
// export const editFeedback = (feedback, id) => async (dispatch) => {
//   await dispatch({ type: GALLERY_LOADING });
//   await firebase
//     .firestore()
//     .collection("gallery")
//     .doc(id)
//     .update({ ...feedback })
//     .then((res) => {
//       dispatch({ type: EDIT_GALLERY });
//       dispatch({ type: GALLERY_LOADING_END });
//     })
//     .catch((err) => {
//       console.log(err);
//       dispatch({ type: EDIT_GALLERY_FAIL });
//       dispatch({ type: GALLERY_LOADING_END });
//     });
// };

// export const deleteFeedback = (id) => async (dispatch) => {
//   await dispatch({ type: GALLERY_LOADING });
//   await firebase
//     .firestore()
//     .collection("gallery")
//     .doc(id)
//     .delete()
//     .then((res) => {
//       dispatch({ type: DELETE_GALLERY });
//       dispatch({ type: GALLERY_LOADING_END });
//     })
//     .catch((err) => {
//       console.log(err);
//       dispatch({ type: DELETE_GALLERY_FAIL });
//       dispatch({ type: GALLERY_LOADING_END });
//     });
// };
